import Cookies from 'js-cookie'

const cookieWrapper = cookieName => ({
  get: () => Cookies.get(cookieName),
  set: (value: string) => Cookies.set(cookieName, value),
  remove: () => Cookies.remove(cookieName),
})

export const getCookies = (guid: string) => ({
  CHANNEL_VIEWER_COOKIE: cookieWrapper('lumiere-channel-viewer'),
  TIMER_COOKIE: cookieWrapper('lumiere-channel-timer-expiration-' + guid),
  TIMER_REDIRECT_COOKIE: cookieWrapper(
    'lumiere-channel-timer-redirect-' + guid
  ),
})
